/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15.0001 6L18.0001 9M15.0001 6L12.0001 9M15.0001 6V10.6C15.0001 12.8402 15.0001 13.9603 14.5641 14.816C14.1806 15.5686 13.5687 16.1805 12.816 16.564C11.9604 17 10.8403 17 8.60008 17H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M15.0001 6L18.0001 9M15.0001 6L12.0001 9M15.0001 6V9.49992C15.0001 11.8297 15.0001 12.9946 14.6195 13.9135C14.112 15.1386 13.1386 16.1119 11.9136 16.6194C10.9947 17 9.82978 17 7.5 17V17H7M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM15.5303 5.46967C15.2375 5.17678 14.7626 5.17678 14.4697 5.46967L11.4697 8.46967C11.1768 8.76256 11.1768 9.23744 11.4697 9.53033C11.7626 9.82322 12.2375 9.82322 12.5303 9.53033L14.25 7.81066V10.6C14.25 11.7325 14.2494 12.5367 14.198 13.1661C14.1473 13.7867 14.0509 14.171 13.8958 14.4755C13.5842 15.087 13.087 15.5842 12.4755 15.8958C12.171 16.0509 11.7868 16.1473 11.1661 16.198C10.5368 16.2494 9.7325 16.25 8.60002 16.25H6.99994C6.58573 16.25 6.24994 16.5858 6.24994 17C6.24994 17.4142 6.58573 17.75 6.99994 17.75H8.60002H8.63304H8.63311C9.72521 17.75 10.5907 17.75 11.2883 17.693C12.0017 17.6347 12.6053 17.5131 13.1565 17.2323C14.0502 16.7769 14.7769 16.0502 15.2323 15.1565C15.5131 14.6053 15.6347 14.0017 15.693 13.2883C15.75 12.5907 15.75 11.7252 15.75 10.633V10.633V10.6V7.81066L17.4697 9.53033C17.7626 9.82322 18.2375 9.82322 18.5303 9.53033C18.8232 9.23744 18.8232 8.76256 18.5303 8.46967L15.5303 5.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 22H9V22C7.13872 22 6.20808 22 5.45492 21.7553C3.93273 21.2607 2.73931 20.0673 2.24472 18.5451C2 17.7919 2 16.8613 2 15V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V15C22 16.8613 22 17.7919 21.7553 18.5451C21.2607 20.0673 20.0673 21.2607 18.5451 21.7553C17.7919 22 16.8613 22 15 22V22H14.5M15.0001 6L18.0001 9M15.0001 6L12.0001 9M15.0001 6V9.49992C15.0001 11.8297 15.0001 12.9946 14.6195 13.9135C14.112 15.1386 13.1386 16.1119 11.9136 16.6194C10.9947 17 9.82978 17 7.5 17V17H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15.0001 6L18.0001 9M15.0001 6L12.0001 9M15.0001 6V9.49992C15.0001 11.8297 15.0001 12.9946 14.6195 13.9135C14.112 15.1386 13.1386 16.1119 11.9136 16.6194C10.9947 17 9.82978 17 7.5 17V17H7M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.4697 5.46967C14.7626 5.17678 15.2375 5.17678 15.5304 5.46967L18.5304 8.46967C18.8233 8.76256 18.8233 9.23744 18.5304 9.53033C18.2375 9.82322 17.7626 9.82322 17.4698 9.53033L15.7501 7.81066V10.6V10.633C15.7501 11.7252 15.7501 12.5906 15.6931 13.2883C15.6348 14.0017 15.5132 14.6053 15.2324 15.1565C14.777 16.0502 14.0503 16.7769 13.1565 17.2323C12.6054 17.5131 12.0017 17.6347 11.2883 17.693C10.5907 17.75 9.72523 17.75 8.6331 17.75H8.60008H7C6.58579 17.75 6.25 17.4142 6.25 17C6.25 16.5858 6.58579 16.25 7 16.25H8.60008C9.73256 16.25 10.5368 16.2494 11.1662 16.198C11.7868 16.1473 12.1711 16.0509 12.4755 15.8958C13.0871 15.5842 13.5843 15.087 13.8959 14.4755C14.051 14.171 14.1474 13.7867 14.1981 13.1661C14.2495 12.5367 14.2501 11.7325 14.2501 10.6V7.81066L12.5304 9.53033C12.2375 9.82322 11.7626 9.82322 11.4697 9.53033C11.1769 9.23744 11.1769 8.76256 11.4697 8.46967L14.4697 5.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
